import LibsView, { LibsViewPanel }  from './LibsView'


export default LibsView

export { LibsViewPanel } 